module.exports = __webpack_public_path__ + "static/media/BoardingPersonalUse.43cb3527.ttf";